module.exports = __webpack_public_path__ + "media/images/icons/filled/lock-673e28102b4163f51c0971e652af5e10.svg";